import { urlUtility } from "@repo/utilities/url.utility.ts";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { removeEmptyFields } from "@repo/utilities/object.utility.ts";
interface IEnquiriesServiceProps extends ICommonServiceProps {
  planId?: number | string;
  partnerId?: number | string;
}

export const useGetAllEnquiriesServices = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
  cacheKeys = [],
  filters = {},
  partnerId = "",
  planId = "",
}: IEnquiriesServiceProps) => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const leadsStageId = urlQueries?.["leads-stage-id"] || "";
  const created_between = urlQueries["created_between"] || "";
  const currFilters = removeEmptyFields({
    "filter[enquiry_stage_id]": leadsStageId,
    "filter[created_between]": created_between,
    "filter[plan_id]": planId,
    "filter[enquiry_partner_id]": partnerId,
    ...{ filters },
  });
  const allEnquiriesServices = useQuery({
    queryKey: [
      ...CACHE_KEYS.LEADS,
      page,
      per_page,
      leadsStageId,
      created_between,
      currFilters,
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.ENQUIRIES,
        searchParams: {
          page: page,
          per_page: per_page,
          include: "enquiry_stage",
          ...currFilters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allEnquiriesServices },
  };
};

export const useGetSingleEnquiry = () => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const enquiry_id = urlQueries["enquiry-id"];
  const getSingleEnquiry = useQuery({
    queryKey: [...CACHE_KEYS.SINGLE_LEAD, enquiry_id],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.ENQUIRIES}/${enquiry_id}`,
      }),
    enabled: enquiry_id ? true : false,
  });
  return {
    services: { getSingleEnquiry },
  };
};

export const useGetAllEnquiryStagesService = ({
  partnerId,
  planId,
}: {
  partnerId?: number;
  planId?: number;
}) => {
  const allEnquiryStagesService = useQuery({
    queryKey: [...CACHE_KEYS.ENQUIRY_STAGES, partnerId, planId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.ENQUIRY_STAGES,
        searchParams: {
          include: "enquiriesCount",
          ...removeEmptyFields({
            "filter[partner_id]": partnerId,
            "filter[plan_id]": planId,
          }),
        },
      }),
  });

  return { services: { allEnquiryStagesService } };
};
